{
  "version": 1,
  "asset_id": "61a9c46b-0c96-4216-a8b6-91cf4446fb27",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/61a9c46b-0c96-4216-a8b6-91cf4446fb27/svc-cro-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/61a9c46b-0c96-4216-a8b6-91cf4446fb27/svc-cro-640.avif",
  "original_filename": "svc-cro-640.avif",
  "size": 4420,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:46Z"
}
